/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Key_HasInputs */

const en_filter_key_has = /** @type {(inputs: Filter_Key_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has`)
};

const de_filter_key_has = /** @type {(inputs: Filter_Key_HasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat`)
};

/**
* | output |
* | --- |
* | "Has" |
*
* @param {Filter_Key_HasInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_key_has = /** @type {((inputs?: Filter_Key_HasInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Key_HasInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_key_has(inputs)
	return en_filter_key_has(inputs)
});